import { Box, Title } from '@mantine/core';
import { Container, ContentWrapper, StyledScrollArea } from './styles';
import { useDomainSelect } from './use-domain-select';
import { DomainItem } from '../../molecules';
import { useElementSize } from '@mantine/hooks';
import { useStore } from '@/store';
import { t } from 'i18next';
import { useSetupStore } from '../../store';

export interface DomainSelectProps {
  children: (progress: () => void, disabled?: boolean) => JSX.Element;
}

export const DomainSelect = ({ children }: DomainSelectProps) => {
  const domains = useStore(({ config: c }) => c.domainAccess);
  const { progressSetup } = useDomainSelect();
  const domain = useSetupStore((s) => s.domain);
  const { ref, height } = useElementSize();

  if (domains.length === 0) {
    // TODO(D): fallback UI?
    return <div>No domains available for the current operator.</div>;
  }

  return (
    <>
      <Container>
        <ContentWrapper>
          <Title order={3} fw={500}>
            {t('title.domainSelect')}
          </Title>

          <Box sx={{ flex: 1 }} ref={ref}>
            <StyledScrollArea h={height - 100}>
              {domains.map((availableDomain) => (
                <DomainItem key={availableDomain} domain={availableDomain} />
              ))}
            </StyledScrollArea>
          </Box>
        </ContentWrapper>
      </Container>

      {children(progressSetup, domain === undefined)}
    </>
  );
};
